import Headroom from 'headroom.js';
import Vue from 'vue';

Vue.component('model-new-cta-bar', {
    data() {
        return {
            allNavigationItems: [],
            allNavItems: null,
            activeLink: '',
        };
    },
    mounted() {
        // grab an element
        const myElement = document.querySelector('.mobile-cta-bar');
        // construct an instance of Headroom, passing the element
        const headroom = new Headroom(myElement);
        // initialise
        headroom.init();

        this.allNavigationItems = document.querySelectorAll('[data-page-nav]');
        this.allNavItems = this.initPageNav();
        this.activeLink = window.location.href;
        this.handleUrlChange();
    },

    watch: {
        '$root.showMenu': function (visible) {
            this.hideCtaBar(visible);
        },

        '$root.showCountries': function (visible) {
            this.hideCtaBar(visible);
        },
    },

    methods: {
        hideCtaBar(visible) {
            const modelCtaBar = document.getElementById('model-cta-bar');
            const body = document.body;

            if (!modelCtaBar) return;

            if (visible) {
                modelCtaBar.style.display = 'none';
                body.style.overflow = 'hidden';
                return;
            }

            modelCtaBar.style.display = 'block';
            body.style.overflow = 'unset';
        },

        handleUrlChange() {
            window.addEventListener('hashchange', (e) => {
                this.activeLink = e.newURL;
            });
        },

        isLinkActive(link) {
            const decodedVal = window.decodeURI(this.activeLink);
            return decodedVal.includes(link)
                ? 'model-new-cta-bar__link--active'
                : '';
        },

        initPageNav() {
            if (!this.allNavigationItems) {
                return;
            }

            const arr = [];
            for (const element of this.allNavigationItems) {
                if (!element.getAttribute('id').length) continue;
                const obj = {
                    title: element.getAttribute('data-page-nav'),
                    anchor: `#${element.getAttribute('id')}`,
                    iconUrl: element.getAttribute('data-navigation-icon') || '',
                };
                arr.push(obj);
            }

            return arr;
        },
    },
});
